import React, { Component } from 'react';
import { InlineTooltip } from '../tooltips';

import TagsInput from 'react-tagsinput';
import { safeDeepGetWithType, safeDeepGet } from 'iotera-base/json';
import { isFunction } from 'iotera-base/object';

const Label = ({
    className,
    children,
    ...props
}) => {
    return (
        <label className="label" {...props}>
            {children}
        </label>
    );
};

export class TextInputTag extends Component {
    constructor() {
        super();
        this.onChange = this.onChange.bind(this);
        this.onReject = this.onReject.bind(this);
    }

    onChange = (id, prefix) => event => {
        let onChange = safeDeepGetWithType(this, ['props', 'onChange']);
        if (isFunction(onChange)) {
            onChange(id, prefix, event);
        }

    }

    onReject = () => event => {
        let onValidationReject = safeDeepGetWithType(this, ['props', 'onValidationReject']);
        if (isFunction(onValidationReject)) {
            onValidationReject(event);
        }
    }

    render() {
        let id = safeDeepGet(this, ['props', 'id'], '');
        let label = safeDeepGetWithType(this, ['props', 'label'], 'Penanda');
        let value = safeDeepGetWithType(this, ['props', 'value'], []);
        let prefix = safeDeepGet(this, ['props', 'prefix'], '');
        let pattern = safeDeepGet(this, ['props', 'pattern'], '/.*/');
        let maxTags = safeDeepGetWithType(this, ['props', 'maxTags'], -1);
        let addKeys = safeDeepGetWithType(this, ['props', 'addKeys'], [9, 13]);
        let customTagClass = safeDeepGetWithType(this, ['props', 'customTagClass'], 'react-tagsinput-tag');
        let placeholder = safeDeepGetWithType(this, ['props', 'placeholder'], 'Add Tag');
        let preventSubmit = safeDeepGet(this, ['props', 'preventSubmit'], '');
        let textTooltip = safeDeepGet(this, ['props', 'textTooltip'], '');
        let onlyUnique = safeDeepGetWithType(this, ['props', 'onlyUnique'], false);
        let required = safeDeepGetWithType(this, ['props', 'textTooltip'], false);
        let emptyClassName = safeDeepGetWithType(this, ['props', 'emptyClassName'], false);

        let className = "col-md-12"
        let classNameRow = "row"
        if (emptyClassName) {
            className = ''
            classNameRow = ''
        }

        let inline = [];

        if (textTooltip !== undefined) {
            inline =
                <InlineTooltip id={id} text={textTooltip} />
        }
        return (
            <div key={id} style={{ marginBottom: 10 }}>
                <div className={classNameRow}>
                    <div className={className} style={{ paddingTop: 2 }}>
                        <div>
                            <Label htmlFor={id}>
                                {label}{required ? "* " : <span className='text-iotera-optional'>{' (Optional) '}</span>}
                                {inline}
                            </Label>
                        </div>
                    </div>
                </div>
                <div className={classNameRow}>
                    <div className={className}  >
                        <div >
                            <TagsInput
                                value={value}
                                onChange={this.onChange(id, prefix)}
                                onlyUnique={onlyUnique}
                                validationRegex={pattern}
                                maxTags={maxTags}
                                addKeys={addKeys}
                                renderTag={
                                    props =>
                                        <span key={props.key}  {...props} className={customTagClass}>
                                            {props.getTagDisplayValue(props.tag)}
                                            {!props.disabled &&
                                                <span className={props.classNameRemove} onClick={(e) => props.onRemove(props.key)} />
                                            }
                                        </span>
                                }
                                inputProps={{
                                    placeholder
                                }}
                                onValidationReject={this.onReject()}
                                preventSubmit={preventSubmit}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}